import SearchIcon from '@heroicons/react/outline/esm/SearchIcon.js'

import { Card } from '@tribeplatform/react-ui-kit/Card'
import { Input } from '@tribeplatform/react-ui-kit/Input'

import { useI18n } from '../i18n/providers/I18nProvider.js'

export const FilterBar = ({ setFilters }) => {
  const intl = useI18n()

  return (
    <Card>
      <Card.Content>
        <Input
          leadingIcon={<SearchIcon />}
          onChange={e => setFilters({ query: e.target.value || undefined })}
          name="search"
          placeholder={intl.$t({
            id: 'MemberList.FilterBar.SearchMembersPlaceholder',
            defaultMessage: 'Search {MEMBERS}...',
          })}
        />
      </Card.Content>
    </Card>
  )
}
